import React from 'react';
import * as mobxReact from 'mobx-react';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { BulkActionModalViewModel } from '../bulk-action-modal.viewmodel';
import OECheckbox from '../../../../../global/oe-checkbox/oe-checkbox';

interface IProps {
    vm: BulkActionModalViewModel;
}

const BulkActionFormPresentation =
    mobxReact.observer(({ vm }: IProps) => {
        const availableDates = vm.getAvailableDates();
        const selectedDates = vm.getSelectedDates();

        return (
            <form className='oe-form upload-meetings-form'>
                <div className='oe-form_body'>
                    <FormField
                        label={vm.formLabelText}
                    >
                        <div className=' m-top-6px'>
                            <OECheckbox
                                checked={!!availableDates.length && availableDates.length === selectedDates.size}
                                onChange={vm.selectAll}
                                label={'Select all'}
                                classNames='oe-form-field__checkbox attendee-form__checkbox m-bottom-12px'
                            />
                        </div>
                        {availableDates.map(({ dateToRender, dateNumber }) => (
                            <div key={dateNumber}>
                                <OECheckbox
                                    checked={selectedDates.has(dateNumber)}
                                    onChange={vm.handleDatesChange}
                                    label={dateToRender}
                                    classNames='oe-form-field__checkbox attendee-form__checkbox m-bottom-12px'
                                    value={`${dateNumber}`}
                                />
                            </div>
                        ))}
                    </FormField>
                </div>
            </form>
        );
    });

export { BulkActionFormPresentation };
